<template>
    <section class="bg-black text-white p-3 lg:p-0">
        <div class="flex justify-end pt-10 pb-20 lg:pb-[160px] lg:px-12">
            <p class="lg:w-1/2">{{ $t('video.introText') }}</p>
        </div>

        <h2 class="text-2xl lg:px-12">{{ $t('video.productions') }}</h2>
        <div class="h-[1px] w-full bg-white my-8"></div>
        <div class="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 lg:gap-8 lg:px-12 pb-32">
            <MoleculeVideosCard
                v-for="video in videos"
                :key="`production-video-${video.id}`"
                :video="video"
            />
        </div>
    </section>
</template>

<script>
import AtomCarouselLoadingBar from "../../global/atoms/AtomCarouselLoadingBar.vue";
import secondsToMinutes from "../../../utils/secondsToMinutes";
import VueSlickCarousel from "vue-slick-carousel";
import MoleculeVideosCard from "../../videos/molecules/MoleculeVideosCard.vue";
import {mapGetters} from "vuex";

export default {
    name: 'OrganismVideosProductions',
    components: {
        MoleculeVideosCard,
        VueSlickCarousel,
        AtomCarouselLoadingBar
    },
    data() {
        return {
            settingsSlider: {
                dots: true,
                arrows: true,
                infinite: true,
                centerPadding: "0px",
                swipeToSlide: true,
                variableWidth: true,
                draggable: true,
                autoplay: true,
                pauseOnHover: true,
                pauseOnFocus: true,
            }
        }
    },
    computed: {
        ...mapGetters('video', {
            videos: 'productionVideos'
        }),
    },
    methods: {
        secondsToMinutes,
    }
}
</script>

<style scoped lang="scss">
.material-symbols-outlined {
    font-variation-settings: 'FILL' 1,
    'wght' 400,
    'GRAD' 0,
    'opsz' 24
}

.overflow-auto {
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    /* Hide scrollbar for Chrome, Safari and Opera */

    &::-webkit-scrollbar {
        display: none;
    }
}

.slick-slider-carousel ::v-deep {
    .slick-slide {
        padding-left: 0;
        padding-right: 20px;
    }

    .slick-list {
        overflow: hidden;
    }

    .slick-prev, .slick-next {
        top: unset;
        height: unset;
        bottom: -105px;
    }

    .slick-dots {
        bottom: -99px;
    }

    .slick-dots li button:before {
        color: rgba(217, 217, 217, 0.60) !important;
        font-size: 30px;
        transition: 0.4s ease-in-out;
    }

    .slick-dots li.slick-active button:before {
        color: #D9D9D9 !important;
    }

    @media (min-width: 1024px) {
        .slick-dots {
            display: none !important;
        }

        .slick-prev, .slick-next {
            top: -95px;
            justify-content: flex-start;
            height: unset;
        }

        .slick-prev {
            right: 80px;
            left: unset;
        }

        .slick-next {
            right: 50px;
        }
    }
}
</style>
